

export const ImageOutline = {
    stroke: "black",
    fill: "none",
    className: "image-outline",
}
